import { Button, cn } from "@workith/ui";
import { LayoutGrid, List } from "lucide-react";
import type { DocumentViewMode } from "./useDocumentViewMode";

interface DocumentViewModeToggleProps {
  viewMode: DocumentViewMode;
  onViewModeChange: (viewMode: DocumentViewMode) => void;
}

const VIEW_MODE_OPTIONS = [
  {
    value: "grid" as const,
    label: "Grid view",
    Icon: LayoutGrid,
  },
  {
    value: "list" as const,
    label: "List view",
    Icon: List,
  },
];

export function DocumentViewModeToggle({
  viewMode,
  onViewModeChange,
}: DocumentViewModeToggleProps) {
  return (
    <fieldset
      className="inline-flex items-center gap-1 rounded-md border bg-muted/40 p-1"
      aria-label="Document view mode"
    >
      {VIEW_MODE_OPTIONS.map(({ value, label, Icon }) => {
        const selected = viewMode === value;

        return (
          <Button
            key={value}
            type="button"
            variant={selected ? "secondary" : "ghost"}
            size="icon"
            className={cn("h-8 w-8", selected && "bg-background shadow-sm")}
            aria-label={label}
            aria-pressed={selected}
            onClick={() => onViewModeChange(value)}
          >
            <Icon className="h-4 w-4" />
          </Button>
        );
      })}
    </fieldset>
  );
}
